"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TaskConfigurationEntity_1 = __importDefault(require("./Entity/TaskConfigurationEntity"));
var TaskConfiguration = /** @class */ (function () {
    function TaskConfiguration(session) {
        this.TaskConfigurationEntity = new TaskConfigurationEntity_1.default(session);
    }
    TaskConfiguration.prototype.getAllActionData = function () {
        return this.TaskConfigurationEntity.getAllActionData();
    };
    TaskConfiguration.prototype.create = function (taskConfiguration) {
        return this.TaskConfigurationEntity.service.create(taskConfiguration);
    };
    TaskConfiguration.prototype.update = function (id, taskConfiguration) {
        return this.TaskConfigurationEntity.service.update(id, taskConfiguration);
    };
    return TaskConfiguration;
}());
exports.default = TaskConfiguration;
//# sourceMappingURL=TaskConfiguration.js.map